export default {
    base_url: 'https://api.sons.co.uk/',
    stripe_publishable_key: 'pk_live_51ITkzDInoyHff90PywgMVvdohMok5vbWLfd5PiHUBzdl7A5s0FPMR8UvGjG4uWuEhZ6TmLkuYJ11QkpdcXEsUMjf00MQEd6ojv'
};